import React from "react";
import { PollingCampaignJoin } from "../../features/callback_campaign/component/PollingCampaignJoin";

export const CallbackCampaign: React.FC = () => {
  return <PollingCampaignJoin />;
};
